import React from 'react';

const InstructionsModal = ({ isOpen, onClose }) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
            <div className="bg-white rounded-lg max-w-4xl w-full max-h-[90vh] overflow-y-auto">
                <div className="p-6">
                    <div className="flex justify-between items-center mb-6">
                        <h1 className="text-2xl md:text-3xl font-semibold text-center w-full text-center">Instructions de Livraison</h1>
                        <button 
                            onClick={onClose}
                            className="text-gray-500 hover:text-gray-700"
                        >
                            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                    </div>
                    
                    <div className="space-y-6">
                        <p className="text-lg text-gray-600 italic mb-8">
                            Bonjour, voici les 5 informations importantes à retenir :
                        </p>

                        <div className="space-y-6">
                            <div className="bg-gray-50 p-4 rounded-lg border-l-4 border-blue-500">
                                <h2 className="text-lg font-semibold mb-2">1. Saisie de l'adresse</h2>
                                <p className="text-gray-700">
                                    Si vous ne trouvez pas votre adresse, saisissez une autre adresse et mettez la bonne adresse dans les commentaires à la fin de votre commande.
                                    Frais de livraison: 15€ par pallier de 100€ d'achat.
                                </p>
                            </div>

                            <div className="bg-gray-50 p-4 rounded-lg border-l-4 border-green-500">
                                <h2 className="text-lg font-semibold mb-2">2. Confirmation de commande</h2>
                                <p className="text-gray-700">
                                    Vérifiez que vous avez bien reçu votre confirmation de commande à l'issue de votre paiement.
                                </p>
                            </div>

                            <div className="bg-gray-50 p-4 rounded-lg border-l-4 border-yellow-500">
                                <h2 className="text-lg font-semibold mb-2">3. Date limite des commandes</h2>
                                <p className="text-gray-700">
                                    <ul className="list-disc pl-4">
                                        <li>Province : Jeudi à 16h</li>
                                        <li>Paris intra-muros : Vendredi 9h</li>
                                    </ul>
                                    <p className="mt-2 text-sm italic">
                                        Pour toute commande après ces horaires, veuillez contacter Nessim au 06.69.23.07.70 pour vérifier la faisabilité.
                                    </p>
                                </p>
                            </div>

                            <div className="bg-gray-50 p-4 rounded-lg border-l-4 border-purple-500">
                                <h2 className="text-lg font-semibold mb-2">4. Horaires de livraison en province</h2>
                                <p className="text-gray-700">
                                    Les livraisons en province sont effectuées le Vendredi matin entre 8h et 13h par notre partenaire Chronofresh.
                                </p>
                            </div>

                            <div className="bg-gray-50 p-4 rounded-lg border-l-4 border-red-500">
                                <h2 className="text-lg font-semibold mb-2">5. Important : Disponibilité téléphonique</h2>
                                <p className="text-gray-700 font-medium">
                                    Vous devez IMPÉRATIVEMENT répondre au téléphone le jeudi et le vendredi matin au livreur de Chronofresh sous peine de voir votre livraison déclinée.
                                </p>
                            </div>
                        </div>

                        <p className="text-xl text-center font-semibold text-gray-800 mt-8">
                            Chabbat Chalom
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default InstructionsModal;